import dataLayer from "./dataLayer";
import { toNested } from "./toNested";

/**
 * Usage:
 *   const appPageLoad = makePageLoad({ section: 'Product' });
 *   const pagePageLoad = appPageLoad.with({ technologyName: 'EV' });
 *   pagePageLoad({ page: 'BEV Basics' }); // fires page_view event
 */
export const makePageLoad = (base = {}) => {
  const pageLoad = (extra = {}) => {
    const resolved = { ...base, ...extra };
    dataLayer.push({ event: "page_view", ...toNested(resolved) });
  };

  pageLoad.with = (more = {}) => makePageLoad({ ...base, ...more });

  return pageLoad;
};

export default makePageLoad;
